

export default function Skill(){
  

    return(<>
    <section id="skills" className="skills section-bg">
      <div className="container">

        <div className="section-title">
          <h2>Skills</h2>
         
        </div>

        <div className="row skills-content">
          <div className="col-lg-6" data-aos="fade-up">
            {/* <Progressbar maxval={80}/> */}
            <div className="progress">
              <span className="skill">Digital marketing strategies<i className="val">100%</i></span>
              <div className="progress-bar-wrap">
                <div id="dmpc" className="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"  >

                </div>
                
              </div>
            </div>
             <div className="progress">
              <span className="skill">Google Ads<i className="val">96%</i></span>
              <div className="progress-bar-wrap">
                <div id="gads" className="progress-bar" role="progressbar" aria-valuenow="96" aria-valuemin="0" aria-valuemax="100"  ></div>
              </div>
            </div>

            <div className="progress">
              <span className="skill">Facebook PPC <i className="val">95%</i></span>
              <div className="progress-bar-wrap">
                <div id="fppc" className="progress-bar" role="progressbar" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"  ></div>
              </div>
            </div>

            <div className="progress">
              <span className="skill">Graphics Designing <i className="val">93%</i></span>
              <div className="progress-bar-wrap">
                <div id="gd" className="progress-bar" role="progressbar" aria-valuenow="93" aria-valuemin="0" aria-valuemax="100"  ></div>
              </div>
            </div>

          </div>

          <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">

            

            <div className="progress">
              <span className="skill">Analytics<i className="val">97%</i></span>
              <div className="progress-bar-wrap">
                <div id="ganalytics" className="progress-bar" role="progressbar" aria-valuenow="97" aria-valuemin="0" aria-valuemax="100" ></div>
              </div>
            </div>

            <div className="progress">
              <span className="skill">Email marketing <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div id="em" className="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" ></div>
              </div>
            </div>

             <div className="progress">
              <span className="skill">Webisite development <i className="val">90%</i></span>
              <div className="progress-bar-wrap">
                <div id="wd" className="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"  ></div>
              </div>
            </div>

             <div className="progress">
              <span className="skill">SEO<i className="val">67%</i></span>
              <div className="progress-bar-wrap">
                <div id="seo" className="progress-bar" role="progressbar" aria-valuenow="67" aria-valuemin="0" aria-valuemax="100" ></div>
              </div>
            </div>

         </div>

        </div>

      </div>
    </section>
    </>);
}